export enum AccountOperationsFeatureFlags {
    AccountOperations = 'account-operations',
    FacilityProfileFloatPoolLink = 'facility-profile-float-pool-link',
    LotusOneUserImport = 'lotusone-user-import',
    SpecialtyRemovalReassign = 'specialty_removal_reassign',
    SearchHospitalsRemoveUnusedProperties = 'search-hospitals-remove-unused-properties',
    FacilityContractAgreements = 'facility-contract-agreements',
    FacilityContractsPristineFacilityColumn = 'facility-profiles-grid-include-pristine-facility',
    FacilityContractsUseSyncClassification = 'facility-contracts-global-facility-state-classification',
    DataDogUserSession = 'data-dog-user-session',
    FacilityContractsAgreementHistory = 'facility-contracts-agreement-history',
    AgreementServices = 'agreement-services',
    FacilityContractsAccountSearch = 'facility-contracts-account-search',
    LotusOneUserImportEmailInvitation = 'lotusone-user-import-email-invitation',
    AgreementAmendments = 'facility-contracts-agreement-amendments'
}
